import { useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { Paper, Chip, CircularProgress } from '../../../../ui';
import { toast } from 'react-toastify';
import {
  IAllocatableHistoryItem,
} from '../../../../@types/allocatable-history.type';
import { getAllocatableHistoryByResourceId } from '../../../../services/api/resource/allocatableHistoryService';
import styles from './styles.module.scss';

interface AllocatableHistoryProps {
  resourceId?: string | null;
}

export interface AllocatableHistoryRef {
  refresh: () => Promise<void>;
}

export const AllocatableHistory = forwardRef<AllocatableHistoryRef, AllocatableHistoryProps>(
  ({ resourceId }, ref) => {
    const [loading, setLoading] = useState(false);
    const [history, setHistory] = useState<IAllocatableHistoryItem[]>([]);

    const fetchHistory = async () => {
      if (!resourceId) return;

      try {
        setLoading(true);
        const data = await getAllocatableHistoryByResourceId(resourceId);
        setHistory(data);
      } catch (error: any) {
        console.log(error)
        toast.error('Erro ao carregar histórico de alocabilidade');
        setHistory([]);
      } finally {
        setLoading(false);
      }
    };

    useImperativeHandle(ref, () => ({
      refresh: async () => {
        await fetchHistory();
      },
    }));

    useEffect(() => {
      fetchHistory();
    }, [resourceId]);

  const displayHistory = [...history].slice(-3).reverse();

  return loading ? (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <CircularProgress size={100} />
    </div>
  ) : !history || history.length === 0 ? (
    <Paper className={styles.projectPaper}>
      <div>Nenhum histórico de alocabilidade disponível</div>
    </Paper>
  ) : (
    <div className={styles.container}>
      <h3 className={styles.title}>Histórico de Alocabilidade</h3>
      <div className={styles.gridWrapper}>
        {displayHistory.map((record, index) => (
          <Paper
            key={record.id}
            className={`${styles.recordCard} ${index === 0 ? styles.firstRecord : ''}`}
          >
            <div className={styles.recordGrid}>
              <div className={styles.gridItem}>
                <span className={styles.label}>Status</span>
                <Chip
                  label={record.status}
                  variant="filled"
                  size="small"
                  className={`${styles.statusChip} ${
                    record.status === 'Alocável' ? styles.allocableStatus : styles.notAllocableStatus
                  }`}
                />
              </div>
              <div className={styles.gridItem}>
                <span className={styles.label}>Início</span>
                <div className={styles.value}>{record.startDate}</div>
              </div>
              <div className={styles.gridItem}>
                <span className={styles.label}>Fim</span>
                <div className={styles.value}>{record.endDate || 'Atual'}</div>
              </div>
              <div className={styles.gridItem}>
                <span className={styles.label}>Autor</span>
                <div className={styles.value}>{record.author}</div>
              </div>
            </div>
          </Paper>
        ))}
      </div>
    </div>
  );
});

AllocatableHistory.displayName = 'AllocatableHistory';